import React from "react";
import { useTranslation } from "react-i18next";
import {
    GridNoRecords,
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { useMediaQuery } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Label } from "@progress/kendo-react-labels";
import "./signatory-list.css";
const TooltipContentTemplate = (props) => {
    return (
        <a>
            <p>{props.content}</p>
        </a>
    );
};

/* ======= Grid component list of signers ======= */
const SignatoryListPure = ({
    signers,
    toggleDialogDeleteSigner,
    type,
    setSigners,
    validateInput,
    isAtgrafSignature,
    signatureTypeId,
    signatureTypeESignChecked,
    signatureTypeAdvancedChecked,
    signatureTypeAutographChecked,
    processTypeAprovationChecked,
    processTypeAprovationSequentialChecked,
    processTypeRandomChecked,
    processTypeSequentialChecked,
}) => {
    const isShowIndex = useMediaQuery("(min-width:530px)");
    const { t } = useTranslation();
    const gridLabelNorecordsStyles = {
        color: "#828282",
        fontSize: "15px",
        fontWeight: 500,
    };
    const trash = (props) => {
        const cellItemStyles = {
            color: "#000000",
            fontSize: "12px",
            fontWeight: 550,
        };
        return (
            <td style={cellItemStyles}>
                {" "}
                <div
                    className="button-signers  delete"
                    onClick={() => {
                        toggleDialogDeleteSigner(props.dataItem);
                    }}
                >
                    {" "}
                    <i
                        style={{ cursor: "pointer" }}
                        className="k-icon k-i-delete k-i-trash"
                    ></i>{" "}
                </div>{" "}
            </td>
        );
    };

    let signatureTypeSelected =
        signatureTypeESignChecked === false &&
            signatureTypeAdvancedChecked === false &&
            signatureTypeAutographChecked === true
            ? true
            : false;

    return (
        <div>
            <Grid className="signer-name" resizable reorderable data={signers}>
                <Column field="nameSigner" title={t("signatoryList2.name")} />
                <Column field="email" title={t("signatoryList2.email")} />
                <Column field="typeName" title="Rol" />
                {isAtgrafSignature && isShowIndex && signatureTypeSelected === true ? (
                    <Column
                        title="Cantidad de firmas"
                        style={{ width: "50px", fontSize: "12px" }}
                        cell={({ dataItem }) => {
                            return (
                                <div className="Tooltip-num-signatory">
                                    <div
                                        style={{
                                            marginTop: "8px",
                                            fontSize: "12px",
                                            marginBottom: "3px",
                                        }}
                                    >
                                        <NumericTextBox
                                            className="input-add-colaborator"
                                            type="name"
                                            name="numSign"
                                            max={99}
                                            style={{ fontSize: "12px" }}
                                            min={1}
                                            value={dataItem.numSign || 1}
                                            onChange={({ value }) => {
                                                setSigners(
                                                    signers.map((item) =>
                                                        dataItem.email === item.email
                                                            ? {
                                                                ...item,
                                                                numSign: value,
                                                            }
                                                            : item
                                                    )
                                                );
                                            }}
                                            component={validateInput}
                                        />
                                    </div>
                                    <Tooltip
                                        position="right"
                                        anchorElement="target"
                                        content={() => (
                                            <TooltipContentTemplate
                                                content={
                                                    "Para este documento y este firmante tienes la opción de solicitar más de una firma, si lo deseas aumenta la cantidad de firmas."
                                                }
                                            />
                                        )}
                                    >
                                        <Label className="form-inputs-labels">
                                            {""}
                                            <i
                                                className="k-icon k-i-information"
                                                // style={iconTooltipStyles}
                                                title={t("signatureRequestView2.tooltipClic")}
                                            // onClick={() => handleOnChangeTooltip()}
                                            // onMouseOut={() => hiddeTooltip()}
                                            />
                                        </Label>
                                    </Tooltip>
                                </div>
                            );
                        }}
                    />
                ) : (
                    ""
                )}
                <Column
                    title={"Acciones"}
                    cell={trash}
                    style={{ paddingTop: "-10px" }}
                // cell={(params) => (
                //     <div className="button-signers  delete" onClick={() => { toggleDialogDeleteSigner(params.dataItem) }}>
                //         <i style={{ cursor: 'pointer' }} className="k-icon k-i-delete k-i-trash"></i>
                //     </div>
                // ) }
                />
                <GridNoRecords>
                    <p style={gridLabelNorecordsStyles}>
                        {t(
                            type === "validators"
                                ? "signatoryList2.notAddValidators"
                                : "signatoryList2.notAddSigners"
                        )}
                    </p>
                </GridNoRecords>
            </Grid>
        </div>
    );
};

export { SignatoryListPure as default };
